// extracted by mini-css-extract-plugin
module.exports = {"Head":"card-head_Head__dBTtH"};